<script>
export default {
  name: "TableTemplate",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="mx-auto flex flex-col">
    <slot name="control"></slot>
    <div class="block rounded-lg shadow-2xl">
      <table class="w-full relative">
        <div
          class="absolute top-0 left-0 h-full bg-black/30 w-full"
          v-if="isLoading"
        >
          <img
            src="/Wait.png"
            alt=""
            class="h-10 w-10 animate-spin fixed top-10"
          />
        </div>
        <slot name="table-content"></slot>
      </table>
    </div>
    <div class="mx-auto p-4">
      <slot name="pagination"></slot>
    </div>
  </div>
</template>

<style scoped></style>
